/**
 * WARNING: Нельзя использовать в качестве значения какую-либо энамку,
 * так как метод используется для подготовки данных для нескольких ручек.
 */
const SERVICE_TYPES: { [key: string]: string } = {
  top3: 'Top3',
  premium: 'PremiumObject',
  paid: 'DebitObject',
  standard: 'standard',
  free: 'FreeObject',
  auction: 'auction',
};

/**
 * Преобразует питонячие (public) типы услуг в шарповые (internal)
 */
export const mapPublicServiceType = (serviceType: string): string | undefined => {
  return SERVICE_TYPES[serviceType];
};
